function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.9375 2.5C8.44531 2.5 8.875 2.92969 8.875 3.4375V5H15.125V3.4375C15.125 2.92969 15.5547 2.5 16.0625 2.5C16.5703 2.5 17 2.92969 17 3.4375V5H18.25C19.6172 5 20.75 6.13281 20.75 7.5V18.75C20.75 20.1172 19.6172 21.25 18.25 21.25H5.75C4.38281 21.25 3.25 20.1172 3.25 18.75V7.5C3.25 6.13281 4.38281 5 5.75 5H7V3.4375C7 2.92969 7.42969 2.5 7.9375 2.5ZM7.9375 6.875H5.75C5.39844 6.875 5.125 7.14844 5.125 7.5V18.75C5.125 19.1016 5.39844 19.375 5.75 19.375H18.25C18.6016 19.375 18.875 19.1016 18.875 18.75V7.5C18.875 7.14844 18.6016 6.875 18.25 6.875H7.9375ZM8.875 12.5V15.625H15.125V12.5H8.875ZM7 12.5C7 11.4844 7.85938 10.625 8.875 10.625H15.125C16.1797 10.625 17 11.4844 17 12.5V15.625C17 16.6797 16.1797 17.5 15.125 17.5H8.875C7.85938 17.5 7 16.6797 7 15.625V12.5Z",
  fill: "#636766"
});

function SvgCalendarReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarReport);
export default __webpack_public_path__ + "static/media/calendar-report.d35aaf5e.svg";
export { ForwardRef as ReactComponent };